import { JobPostChannel } from '../types';

const validPostChannels: string[] = Object.values(JobPostChannel);

export const isValidPostChannel = (
  postChannel: string,
): postChannel is JobPostChannel => validPostChannels.includes(postChannel);
